import { nextTick, onBeforeUnmount, onMounted, reactive, ref, watchEffect } from "vue"

// Заголовок экрана живёт в шапке шелла, а не внутри страницы
// (docs/10-design/patterns.md). Экран объявляет его этим composable, шапку
// рисует layout/Base/PageHeaderView.vue.
//
// Пока экран не переписан под дизайн-систему, он ничего не объявляет и шапка
// не показывается — заголовок остаётся внутри самой страницы. Это позволяет
// переводить экраны по одному.
//
//   usePageHeader(() => ({ title: schedule.value?.title, crumb: "Расписание" }))
//
// Кнопки действий экран телепортирует в шапку:
//
//   Teleport(to="#page-header-actions")
//     AppButton(...)

const state = reactive({
  title: "",
  crumb: ""
})

export const pageHeader = state

export const usePageHeader = (source) => {
  const resolve = () => (typeof source === "function" ? source() : source)

  // flush: "post" — состояние шапки меняется после отрисовки экрана, иначе
  // запись в него посреди рендера дочернего компонента ломает патч Vue.
  watchEffect(() => {
    const value = resolve() || {}
    state.title = value.title || ""
    state.crumb = value.crumb || ""
  }, { flush: "post" })

  onBeforeUnmount(() => {
    state.title = ""
    state.crumb = ""
  })
}

// Кнопки экрана уезжают в шапку телепортом, но при переходе между layout'ами
// поддерево строится вне документа: querySelector("#page-header-actions") на
// этапе mount возвращает null и патч Vue падает. Ref включает телепорт только
// после вставки дерева в документ.
//
//   const headerReady = usePageHeaderActionsReady()
//   Teleport(v-if="headerReady" to="#page-header-actions")
export const usePageHeaderActionsReady = () => {
  const ready = ref(false)

  onMounted(async () => {
    await nextTick()
    ready.value = !!document.querySelector("#page-header-actions")
  })

  return ready
}
